const { colors } = require("./colors");

const linkOnLight = {
  default: {
    color: colors.black,
    textDecoration: "none",
  },
  hover: {
    color: colors.linkHover.dark,
    textDecoration: "underline",
  },
};

const interaction = {
  transition:
    "color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease, opacity 0.2s ease",

  button: {
    solid: {
      default: {
        background: colors.black,
        color: colors.white,
        border: colors.black,
      },
      hover: {
        background: colors.white,
        color: colors.black,
        border: colors.black,
      },
      disabled: {
        background: colors.grey.medium,
        color: colors.grey.darkMedium,
        border: colors.grey.medium,
      },
    },
    outlined: {
      default: {
        background: "transparent",
        color: colors.black,
        border: colors.black,
      },
      hover: {
        background: colors.black,
        color: colors.white,
        border: colors.black,
      },
      disabled: {
        background: "transparent",
        color: colors.grey.darkMedium,
        border: colors.grey.medium,
      },
    },
    ghost: {
      default: {
        background: "transparent",
        color: colors.black,
        border: "transparent",
      },
      hover: {
        background: colors.black,
        color: colors.white,
        border: "transparent",
      },
      disabled: {
        background: "transparent",
        color: colors.grey.darkMedium,
        border: "transparent",
      },
    },
  },

  iconButton: {
    hoverAlpha: 0.2,
  },

  link: {
    default: linkOnLight.default,
    hover: linkOnLight.hover,
    muted: {
      default: { color: colors.grey.medium },
      hover: { color: colors.linkHover.light, textDecoration: "underline" },
    },
  },

  textAction: {
    default: { color: colors.accentContent },
    hover: {
      color: colors.linkHover.dark,
      textDecoration: "underline",
    },
  },
};

module.exports = { interaction };
